import { select, call, put, takeLatest } from "redux-saga/effects";

import { ApiService } from "pwapi";

import {
  ADMIN_CASES_SUCCESS,
  ADMIN_CASES_REQUEST,
  ADMIN_CASES_FAILURE,
  ADMIN_UPDATE_CASE_REQUEST,
  ADMIN_UPDATE_CASE_SUCCESS,
  ADMIN_UPDATE_CASE_FAILURE,
  ADMIN_DELETE_CASE_REQUEST,
  ADMIN_UPDATE_SPECIMEN_FAILURE,
  ADMIN_UPDATE_SPECIMEN_SUCCESS,
  ADMIN_UPDATE_SPECIMEN_REQUEST,
  ADMIN_DELETE_CASE_FAILURE,
  ADMIN_DELETE_CASE_SUCCESS,
  ADMIN_UPDATE_QAREVIEW_FAILURE,
  ADMIN_UPDATE_QAREVIEW_SUCCESS,
  ADMIN_UPDATE_QAREVIEW_REQUEST,
  ADMIN_CREATE_QAREVIEW_SUCCESS,
  ADMIN_CREATE_QAREVIEW_FAILURE,
  ADMIN_CREATE_QAREVIEW_REQUEST,
  ADMIN_UPDATE_INTEGRATIONS_REQUEST,
  ADMIN_UPDATE_INTEGRATIONS_SUCCESS,
  ADMIN_UPDATE_INTEGRATIONS_FAILURE,
  BULK_UPDATE_CASES_FAILURE,
  BULK_UPDATE_CASES_REQUEST,
} from "../actions/adminConstants";

function* fetchCases(action: any): any {
  try {
    const result = yield call(
      ApiService.listAdminCases,
      action.payload.filters
    );
    let manualCount = undefined;
    if (action.payload.isManualReview) {
      manualCount = yield call(ApiService.countAdminSlide);
    }
    yield put({
      type: ADMIN_CASES_SUCCESS,
      payload: {
        ...result,
        slideCount: manualCount,
        params: action.payload.filters || {},
      },
    });
  } catch (e) {
    yield put({
      type: ADMIN_CASES_FAILURE,
      error: true,
      payload: e,
    });
  }
}

function* saveCase(action: any): any {
  try {
    const result = yield call(ApiService.partialUpdateAdminCase, {
      id: action.payload.id,
      requestBody: action.payload,
    });
    yield put({ type: ADMIN_UPDATE_CASE_SUCCESS, payload: result });
  } catch (e) {
    yield put({
      type: ADMIN_UPDATE_CASE_FAILURE,
      error: true,
      payload: e,
    });
  }
}

function* deleteCase(action: any): any {
  try {
    yield call(ApiService.destroyCase, { id: action.payload.adminCase.id });
    yield put({ type: ADMIN_DELETE_CASE_SUCCESS, payload: action.payload });
    yield action.payload.navigate(
      action.payload.historyState?.prevUrl
        ? action.payload.historyState.prevUrl
        : "/admin"
    );
  } catch (e) {
    yield put({
      type: ADMIN_DELETE_CASE_FAILURE,
      error: true,
      payload: e,
    });
  }
}

function* saveSpecimen(action: any): any {
  try {
    const result = yield call(ApiService.partialUpdateAdminSpecimen, {
      id: action.payload.specimen.id,
      requestBody: action.payload.specimen,
    });
    yield put({
      type: ADMIN_UPDATE_SPECIMEN_SUCCESS,
      payload: {
        specimen: result,
        case_id: action.payload.case_id,
      },
    });
    // Run the gross description update side effect
    result.gross_desc_find_replace &&
      action.payload.onGrossDescriptionUpdate(result.gross_desc_find_replace);
    action.payload.onClose && action.payload.onClose();
  } catch (e) {
    yield put({
      type: ADMIN_UPDATE_SPECIMEN_FAILURE,
      error: true,
      payload: e,
    });
  }
}

function* updateQAReview(action: any): any {
  try {
    yield put({
      type: ADMIN_UPDATE_QAREVIEW_SUCCESS,
      payload: action.payload,
    });
  } catch (e) {
    yield put({
      type: ADMIN_UPDATE_QAREVIEW_FAILURE,
      error: true,
      payload: e,
    });
  }
}

function* createQAReview(action: any): any {
  try {
    const response = yield call(ApiService.createAdminCaseQaReview, {
      parentLookupCaseId: action.payload.caseId,
      requestBody: {
        reviewed: action.payload.reviewed,
        note: action.payload.note,
      },
    });
    yield put({
      type: ADMIN_CREATE_QAREVIEW_SUCCESS,
      payload: response,
    });

    action.payload.onClose && action.payload.onClose();
  } catch (e) {
    yield put({
      type: ADMIN_CREATE_QAREVIEW_FAILURE,
      error: true,
      payload: e,
    });
  }
}

function* updateIntegrations(action: any): any {
  try {
    const response = yield call(
      ApiService.partialUpdateIntegrationAdminViewSet,
      {
        requestBody: action.payload,
      }
    );
    yield put({
      type: ADMIN_UPDATE_INTEGRATIONS_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({
      type: ADMIN_UPDATE_INTEGRATIONS_FAILURE,
      error: true,
      payload: e,
    });
  }
}

const getCasesParams = (state: any) => state.admin.cases.params;

function* bulkUpdateCases(action: any): any {
  try {
    const state = yield select(getCasesParams);
    yield call(ApiService.createCaseBulk, {
      requestBody: {
        bulk_action: action.payload.bulkAction,
        bulk_value: action.payload.updateValue,
        object_ids: action.payload.caseIds,
      },
    });
    yield put({
      type: ADMIN_CASES_REQUEST,
      payload: { filters: state },
    });
  } catch (e) {
    yield put({
      type: BULK_UPDATE_CASES_FAILURE,
      error: true,
      payload: e,
    });
  }
}

export function* adminCasesSaga() {
  yield takeLatest(ADMIN_CASES_REQUEST, fetchCases);
  yield takeLatest(ADMIN_UPDATE_CASE_REQUEST, saveCase);
  yield takeLatest(ADMIN_DELETE_CASE_REQUEST, deleteCase);

  yield takeLatest(ADMIN_UPDATE_SPECIMEN_REQUEST, saveSpecimen);

  yield takeLatest(ADMIN_CREATE_QAREVIEW_REQUEST, createQAReview);
  yield takeLatest(ADMIN_UPDATE_QAREVIEW_REQUEST, updateQAReview);
  yield takeLatest(ADMIN_UPDATE_INTEGRATIONS_REQUEST, updateIntegrations);
  yield takeLatest(BULK_UPDATE_CASES_REQUEST, bulkUpdateCases);
}
